module.exports = __webpack_public_path__ + "static/media/user-profile.471a1ad3.png";